import { createStore } from 'redux';

function specialityStore(state = { data: {} }, action) {
    switch (action.type) {
      case 'SPECIALITY_INFO':
        return {
          data: action.data ? action.data : {}
        };
      default:
        return state;
    }
  }
  

let specialityReduxStore = createStore(specialityStore);

export default specialityReduxStore ;